import React from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import {
  ENTERED,
  ENTERING,
  EXITED,
  EXITING,
} from 'react-transition-group/Transition';
import valentinoLoading from '../utils/valentinoLoading';

export default ({ visible, ...props }) => (
  <Transition in={visible} timeout={500} unmountOnExit>
    {state => (
      <Overlay {...props} state={state} />
    )}
  </Transition>
);

const Overlay = styled.div`
  // Header is 9999
  z-index: 9998;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: ${({ state }) => state === EXITED ? 'none' : 'flex'};
  align-items: center;
  justify-content: center;
  opacity: ${({ state }) => {
    switch (state) {
      case ENTERED:
      case ENTERING:
        return 1;

      case EXITING:
      case EXITED:
      default:
        return 0;
    }
  }};
  transition: opacity 300ms ease;
  background: url(${valentinoLoading}) center no-repeat,
              ${props => props.theme.primaryBackgroundColor};
  background-size: 8.125rem 2.1875rem;
`;
